import { useHistory } from "react-router-dom";
import { toast } from "sonner";
import { AuthSubmitButton } from "@/components/molecules/auth/submit-button";
import { useBoomerForm } from "@/form/boomer/hook";
import { useValidator } from "@/form/common/validator";
import { Routes } from "@/lib/router";
import { logger } from "@/logger";

export function RegisterForm() {
  const history = useHistory();
  const validator = useValidator();

  const [form, { Element: FormElement }] = useBoomerForm({
    defaultValues: {
      fullName: "",
      email: "",
      phone: "",
      motivation: "",
    },
    onSubmit: async ({ value: _ }) => {
      try {
        // Navigate to success page
        history.push(Routes.AuthRegisterSuccess());
      } catch (error) {
        logger.error("Registration error:", error);
        toast.error(
          "Er is iets misgegaan bij het verzenden van je registratie. Probeer het later opnieuw.",
        );
      }
    },
  });

  return (
    <FormElement className="flex flex-col gap-6">
      <form.AppField
        name="fullName"
        validators={{
          onBlur: validator.required({ name: "fullName" }),
          onSubmit: validator.required({ name: "fullName" }),
        }}
        children={(field) => (
          <field.InputField
            type="text"
            label="Volledige naam"
            placeholder="Voer je volledige naam in"
            required
          />
        )}
      />
      <form.AppField
        name="email"
        validators={{
          onBlur: validator.required({ name: "email" }),
          onSubmit: validator.email({ schema: validator.required({ name: "email" }) }),
        }}
        children={(field) => (
          <field.InputField
            type="email"
            label="E-mailadres"
            placeholder="Voer je e-mailadres in"
            required
          />
        )}
      />
      <form.AppField
        name="phone"
        validators={{
          onBlur: validator.required({ name: "phone" }),
          onSubmit: validator.required({ name: "phone" }),
        }}
        children={(field) => (
          <field.InputField
            type="tel"
            label="Telefoonnummer"
            placeholder="Voer je telefoonnummer in"
            required
          />
        )}
      />
      <form.AppField
        name="motivation"
        validators={{
          onBlur: validator.required({ name: "motivation" }),
          onSubmit: validator.required({ name: "motivation" }),
        }}
        children={(field) => (
          <field.TextareaField
            label="Motivatie"
            placeholder="Vertel ons waarom je wilt deelnemen"
            required
            rows={4}
          />
        )}
      />
      <form.Subscribe
        selector={(state) => [state.isSubmitting] as const}
        children={([isSubmitting]) => (
          <AuthSubmitButton type="submit" isSubmitting={isSubmitting}>
            Registreren
          </AuthSubmitButton>
        )}
      />
    </FormElement>
  );
}
